import React from "react";
import { Form, Col } from "react-bootstrap";
import { InputField } from "../../../components/InputField";

const VITSFields = ({ setVoiceConfig, setVoiceModel, setFileInputFilled, fileInputFilled, id }) => {
    return (
        <>
            <Form.Row>
                <Form.Group as={Col} lg="6" xs="12">
                    <InputField
                        type="file"
                        name="voiceConfig"
                        label="Configuração do Modelo (.json)"
                        accept=".json"
                        onChange={event => {
                            setVoiceConfig(event.target.files[0]);
                            if (event.target.files.length > 0) {
                                setFileInputFilled(true);
                            }
                        }}
                        required={!id || fileInputFilled}
                    />
                </Form.Group>
                <Form.Group as={Col} lg="6" xs="12">
                    <InputField
                        type="file"
                        name="voiceModel"
                        label="Arquivo do Modelo (.pth)"
                        accept=".pth"
                        onChange={event => {
                            setVoiceModel(event.target.files[0]);
                            if (event.target.files.length > 0) {
                                setFileInputFilled(true);
                            }
                        }}
                        required={!id || fileInputFilled}
                    />
                </Form.Group>
            </Form.Row>
        </>
    );
};

export default VITSFields;